var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "currentColor",
    clipRule: "currentColor",
    d: "M2.1422 6.41792C2.48098 4.85631 3.82292 3.70001 5.42381 3.70001H12.5762C14.1771 3.70001 15.519 4.85631 15.8578 6.41792L17.8172 15.4502C18.278 17.574 16.7423 19.6936 14.5356 19.6936H3.46435C1.25771 19.6936 -0.278002 17.574 0.182741 15.4502L2.1422 6.41792ZM5.42381 5.50001C4.72446 5.50001 4.07229 6.01128 3.90128 6.79954L1.94182 15.8318C1.70191 16.9377 2.50945 17.8936 3.46435 17.8936H14.5356C15.4905 17.8936 16.2981 16.9377 16.0582 15.8318L14.0987 6.79954C13.9277 6.01128 13.2755 5.50001 12.5762 5.50001H5.42381Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "currentColor",
    clipRule: "currentColor",
    d: "M7.47033 3.70001H10.5296C10.4353 3.14772 10.2566 2.76415 10.0593 2.51232C9.78521 2.1625 9.4265 2.00001 8.99998 2.00001C8.57345 2.00001 8.21474 2.1625 7.94065 2.51232C7.74334 2.76415 7.56468 3.14772 7.47033 3.70001ZM6.52377 1.40217C7.1545 0.597166 8.04579 0.200012 8.99998 0.200012C9.95416 0.200012 10.8455 0.597166 11.4762 1.40217C12.0905 2.18616 12.4 3.27962 12.4 4.60001V5.50001H5.59998V4.60001C5.59998 3.27962 5.9095 2.18616 6.52377 1.40217Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1404 14.3087L9.93712 14.2638V9.67098H10.834L10.8373 9.73888C10.857 10.144 11.1912 10.4623 11.5968 10.4623C12.0167 10.4623 12.3571 10.1219 12.3571 9.70194V9.01087C12.3571 8.50782 11.9493 8.10001 11.4463 8.10001H6.55848C6.05543 8.10001 5.64762 8.50782 5.64762 9.01087V9.7074C5.64762 10.1243 5.9856 10.4623 6.40253 10.4623C6.80343 10.4623 7.13441 10.1489 7.15631 9.74865L7.16056 9.67098H8.0484V14.2638L7.84509 14.3087C7.5367 14.3767 7.3171 14.65 7.3171 14.9658C7.3171 15.3374 7.61838 15.6387 7.99003 15.6387H9.99549C10.3671 15.6387 10.6684 15.3374 10.6684 14.9658C10.6684 14.65 10.4488 14.3767 10.1404 14.3087Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTonIcon);
export default __webpack_public_path__ + "static/media/tonIcon.765d1c9f.svg";
export { ForwardRef as ReactComponent };